
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertSettings as ObiAlertSettingsElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-settings.js';
 
 
 

 
 export const ObiAlertSettings = createComponent({
   react: React,
   tagName: 'obi-alert-settings',
   elementClass: ObiAlertSettingsElement,
   events: {
     
   }
  });
 
 